import { Tag, theme } from 'antd';
import type { TagProps } from 'antd';

/**
 * PurpleTag - Theme-aware purple tag component
 *
 * Uses the application's purple theme tokens to ensure consistency
 * across light and dark modes. This component should be used instead
 * of hardcoded `<Tag color="purple">`.
 *
 * @example
 * <PurpleTag>Electronics</PurpleTag>
 * <PurpleTag closable onClose={handleClose}>Category</PurpleTag>
 */
const PurpleTag = ({ children, style, ...props }: TagProps) => {
  const { token } = theme.useToken();

  return (
    <Tag
      style={{
        backgroundColor: token.colorPrimaryBg,
        color: token.colorPrimary,
        borderColor: token.colorPrimaryBorder,
        borderRadius: token.borderRadiusSM,
        ...style,
      }}
      {...props}
    >
      {children}
    </Tag>
  );
};

export default PurpleTag;
